import React from 'react';
import './App.css';
import Header from './components/Header';
import FilesDragAndDrop from "./components/FilesDragAndDrop";
import {Tab, Tabs} from "@mui/material";
import casLogo from "./images/footer-logo.png";
import casLoginLogo from "./images/coastal-administrative-services_1.png";
import Help from "./components/Help";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import HelpIcon from '@mui/icons-material/Help';
import ReinsContract from "./components/VBAPIComponents/ReinsContract";
import DeleteArea from "./components/VBAPIComponents/DeleteArea";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import {withAuthenticator} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import {type AuthUser, fetchAuthSession} from "aws-amplify/auth";
import {type UseAuthenticator} from "@aws-amplify/ui-react-core";
import VBAMaintenance from "./components/VBAPIComponents/VBAMaintenance/VBAMaintenance";
import EngineeringIcon from '@mui/icons-material/Engineering';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import Reports from "./components/VBAPIComponents/Reports/Reports";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccumRecalculator from "./components/VBAPIComponents/AccumRecalculator";
import UseInactivityLogout from './components/UserInactivityLogout';
import ClaimFormsDragAndDrop from "./components/ClaimFormsDragAndDrop";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DataExtractionArea from "./components/VBAPIComponents/DataExtractionArea";
import SubIDFileDrop from "./components/VBAPIComponents/SubIDFileDrop";

type AppProps = {
    signOut?: UseAuthenticator["signOut"]; //() => void;
    user?: AuthUser;
};

const MyCustomSignInHeader = () => (
    <div style={{textAlign: 'center', padding: '20px', color: "black"}}>
        <img
             src={casLoginLogo}
             alt="casLoginLogo"
             style={{height: '4.5vh'}}
        />
        <h2>Welcome Back!</h2>
        <p>Sign in to your account to continue.</p>
    </div>
);

const App: React.FC<AppProps> = ({signOut, user}) => {
    //console.log(user);
    //test

    const getCurrentSession = async () => {
        const session = await fetchAuthSession();
        //console.log("Token: ",session);
        //console.log(stuff);
        //let authToken = JSON.stringify(session.tokens?.idToken);
        refreshToken();
        return session.tokens?.idToken?.toString();
        //return session.tokens?.idToken;
    }

    const refreshToken = () => {
        setTimeout(() => getCurrentSession().then(jwt => jwt ? localStorage.setItem('jwt', jwt) : localStorage.setItem('jwt', "")), 28800000);
    }

    setTimeout(() => {signOut ? signOut() : fetchAuthSession({forceRefresh: true})}, 28800000);

    getCurrentSession().then(jwt => jwt ? localStorage.setItem('jwt', jwt) : localStorage.setItem('jwt', ""));

    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);

    const handleTabChange = (e : any, tabIndex : any) => {
        //console.log(tabIndex);
        setCurrentTabIndex(tabIndex);
    };

    return (
        <div className="App">
            <div>
                {/*<Heading level={1}>Hello {user?.username}</Heading>*/}
                {/*<Button onClick={signOut}>Sign out</Button>*/}
            </div>
            <UseInactivityLogout timeoutMs={1000 * 60 * 15} warningTimeoutMs={1000 * 60 * 10} signOut={signOut}/>
            <Header casLogo={casLogo} signOut={signOut}/>
            <React.Fragment>
                <Tabs value={currentTabIndex} onChange={handleTabChange}>
                    <Tab icon={<FileUploadIcon/>} label='Census File Drop'
                         style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<LibraryBooksIcon/>} label='Reins. Contract' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<CurrencyExchangeIcon/>} label='Accum Recalc' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<EngineeringIcon/>} label='VBA Maintenance' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<PictureAsPdfIcon/>} label='Claim Forms' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<AnalyticsIcon/>} label='Custom Reports' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<DownloadIcon/>} label='Bulk Data Extract' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<ChangeCircleIcon/>} label='Sub ID Change' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<DeleteForeverIcon/>} label='Data Deletion' style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                    <Tab icon={<HelpIcon/>} label='Help'
                         style={{width: "10%", background: '#3B6BA3', fontWeight: 'bolder'}}/>
                </Tabs>
            </React.Fragment>
            <span className="App-header">
                {currentTabIndex === 0 && <FilesDragAndDrop></FilesDragAndDrop>}
                {currentTabIndex === 1 && <ReinsContract></ReinsContract>}
                {currentTabIndex === 2 && <AccumRecalculator></AccumRecalculator>}
                {currentTabIndex === 3 && <VBAMaintenance></VBAMaintenance>}
                {currentTabIndex === 4 && <ClaimFormsDragAndDrop></ClaimFormsDragAndDrop>}
                {currentTabIndex === 5 && <Reports></Reports>}
                {currentTabIndex === 6 && <DataExtractionArea></DataExtractionArea>}
                {currentTabIndex === 7 && <SubIDFileDrop></SubIDFileDrop>}
                {currentTabIndex === 8 && <DeleteArea></DeleteArea>}
                {currentTabIndex === 9 && <Help></Help>}
            </span>
        </div>
    );
}

export default withAuthenticator(App, {hideSignUp: true, components: {SignIn: {Header: MyCustomSignInHeader}}});
